// extracted by mini-css-extract-plugin
module.exports = {"link":"UpF4ZHMO","primary":"_63E6xpud","simple":"-pq6q-NN"};